export default __webpack_public_path__ + "static/media/rupee-secondary-color.a58252dc.svg";